import { Injectable } from "@angular/core";
import { CollectionConfig } from "akita-ng-fire";
import { FirebaseService } from "../firebase.service";
import { PricelistsState, PricelistsStore } from "./pricelists.store";

@Injectable({ providedIn: "root" })
@CollectionConfig({ path: "pricelists" })
export class PricelistsService extends FirebaseService<PricelistsState> {
    constructor(store: PricelistsStore) {
        super(store);
    }
}
